import React from 'react'
import { getPathPrefix } from '../../../shared/webcomponents/helpers/href'

type Props = {
    onClick?: () => void
    className?: string
    imageUrl: string
    titleText?: string
    detailText: string
    compact?: boolean
}

/**
 * We don't really want to prefix this with 'Zaptic' but there is another component with the same name.
 * Don't copy this naming convention.
 *
 * @see zaptic-report-tile.css for the styles
 * @see zaptic-report-tile.tsx for the LitElement
 */
export function ZapticReportTile(props: Props) {
    const pathPrefix = getPathPrefix()
    const missingImagePath = `${pathPrefix}shared/images/missing-unit.svg`
    const src = props.imageUrl === undefined || props.imageUrl === '' ? missingImagePath : props.imageUrl

    return (
        <div className={props.className ? props.className : 'AppCore__ZapticReportTile'} onClick={props.onClick}>
            <div className="AppCore__ZapticReportTile__wrapper">
                <div className="AppCore__ZapticReportTile__image-wrapper">
                    <img src={src} />
                </div>
                <div className="AppCore__ZapticReportTile__info-wrapper">
                    {!props.compact && (
                        <span className="AppCore__ZapticReportTile__info-title"> {props.titleText} </span>
                    )}
                    {props.detailText && (
                        <span className="AppCore__ZapticReportTile__info-name"> {props.detailText} </span>
                    )}
                </div>
            </div>
        </div>
    )
}
